import SiteFooter from '@/components/feature/SiteFooter';
import SiteNavbar from '@/components/feature/SiteNavbar';
import { Certifications, Packaging, ProductGrid, ProductsHero } from './components/Sections';

export default function Products() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNavbar />
      <main>
        <ProductsHero />
        <ProductGrid />
        <Certifications />
        <Packaging />
      </main>
      <SiteFooter />
    </div>
  );
}